import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setData } from 'src/storage/general.actions';

@Component({
  selector: 'app-no-cumple-politicas',
  templateUrl: './no-cumple-politicas.component.html',
  styleUrl: './no-cumple-politicas.component.scss'
})
export class NoCumplePoliticasComponent {
  private store = inject(Store);
  router = inject(Router);

  cleanStore(){
    this.store.dispatch(setData({
      key: 'Property',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'Tenant',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'PolicyHolder',
      value: undefined,
      merge: false
    }));
  }

  goBack(){
    this.cleanStore();
    this.router.navigate(['/seguros/hogar/arriendo/cotizador']).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }
}
